module.exports = __webpack_public_path__ + "static/media/email_icon.3977b487.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/email_icon.png
// module id = 1798
// module chunks = 0